import { useEffect, useMemo } from 'react';
import { showError } from '@utils';
import { useQuery } from 'react-query';
import { useRouter } from 'next/router';

import { QUERY_KEYS } from 'constants/queryKeys';
import { useAssignees, useServicePoints } from '@hooks';

import { boardsServices } from '@services';

import { handleServicePoints, handleLogisticTask } from './utils';

const useLogisticsTaskOperations = () => {
  const {
    query: { logisticTaskId },
  } = useRouter();

  const {
    servicePointsWithDefaultLocations,
    isLoading: isServicePointsLoading,
  } = useServicePoints();
  const { drivers, isLoading: driversLoading } = useAssignees();

  const logisticsResponse = useQuery(
    [QUERY_KEYS.GET_LOGISTIC_KEY, logisticTaskId],
    () => boardsServices.getTaskById(logisticTaskId),
    { enabled: !!logisticTaskId }
  );

  // servicePointsWithDefaultLocations with airport and resorted
  const servicePoints = useMemo(
    () => handleServicePoints(servicePointsWithDefaultLocations),
    [servicePointsWithDefaultLocations]
  );

  const currentLocations = useMemo(
    () => [
      {
        text: '-',
        value: '',
      },
      ...servicePointsWithDefaultLocations,
    ],
    [servicePointsWithDefaultLocations]
  );

  const logisticTask = logisticsResponse.isFetched
    ? handleLogisticTask({
        data: logisticsResponse?.data?.data || {},
        assignees: drivers,
        servicePoints,
        currentLocations,
      })
    : {};
  const loading =
    driversLoading || logisticsResponse?.isLoading || isServicePointsLoading;

  useEffect(() => {
    if (logisticsResponse?.error) {
      showError(logisticsResponse?.error);
    }
  }, [logisticsResponse?.error]);

  return {
    logisticTaskId,
    loading,
    logisticTask,
    assignees: drivers,
    servicePoints,
    getLogisticData: logisticsResponse.refetch,
  };
};

export default useLogisticsTaskOperations;
